import { EventEmitter } from "events";

import Dispatcher from "./dispatcher";
import Constants from "./constants";
import getSidebarNavItems from "../data/sidebar-nav-items";
import getAsociados from "../data/asociados";
import getEfectores from "../data/efectores";
import getVisitas from "../data/visitas";

let _store = {
  menuVisible: false,
  navItems: getSidebarNavItems(),
  asoiciados: getAsociados(),
  efectores: getEfectores(),
  visitas: getVisitas()

};

class Store extends EventEmitter {
  constructor() {
    super();

    this.registerToActions = this.registerToActions.bind(this);
    this.toggleSidebar = this.toggleSidebar.bind(this);

    Dispatcher.register(this.registerToActions.bind(this));
  }

  registerToActions({ actionType, payload }) {
    switch (actionType) {
      case Constants.TOGGLE_SIDEBAR:
        this.toggleSidebar();
        break;
      default:
    }
  }

  toggleSidebar() {
    _store.menuVisible = !_store.menuVisible;
    this.emit(Constants.CHANGE);
  }

  getMenuState() {
    return _store.menuVisible;
  }

  getSidebarItems() {
    return _store.navItems;
  }

  getAsociados() {

    return _store.asoiciados.map( item => {
      const practicas = item.practicas.map( practica => ({
        ...practica,
        efectores: [
          {
            id: 101,
            nombre: "Gerardo Martín Compunsano",
            fecha_desde: "20/10/2019",
            fecha_hasta: "",
            parent_id: item.id

          },
          {
            id: 102,
            nombre: "Mariano Raul Rodriguez",
            fecha_desde: "10/10/2019",
            fecha_hasta: "20/10/2019",
            parent_id: item.id
          }
        ]
      }))

      return ({
       ...item,
       practicas,
       efectores: [
         {
           id: 101,
           nombre: "Gerardo Martín Compunsano",
           fecha_desde: "20/10/2019",
           fecha_hasta: "",
           parent_id: item.id

         },
         {
           id: 102,
           nombre: "Mariano Raul Rodriguez",
           fecha_desde: "10/10/2019",
           fecha_hasta: "20/10/2019",
           parent_id: item.id
         }
       ] })
    });

  }

  getEfectores() {
    return _store.efectores;
  }

  getVisitas() {
    return _store.visitas;
  }

  addChangeListener(callback) {
    this.on(Constants.CHANGE, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(Constants.CHANGE, callback);
  }
}

export default new Store();
